/**
 * True when rich-text HTML actually contains visible text, ignoring empty
 * editor markup (e.g. `<p></p>`, `<p><br></p>`), `&nbsp;` and whitespace.
 */
export const hasRichTextContent = (html?: string | null): boolean =>
  !!html &&
  html
    .replace(/<[^>]*>/g, '')
    .replace(/&nbsp;/g, ' ')
    .trim().length > 0;

export default hasRichTextContent;
